import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

import { type ClaimTypeName, getClaimTypeDisplayName } from "../../lib/claim-types";

const CLAIM_TYPE_NAMES: ClaimTypeName[] = [
  "FLIGHT_DELAY",
  "FLIGHT_CANCELLATION",
  "WRONG_ARRIVAL_AIRPORT",
  "MISSED_CONNECTION_DUE_TO_DELAY",
  "OVERBOOKING",
  "COVID_ORDINANCE_2020",
  "PNR_SEGMENT_CANCELLATION",
  "DELAY_FROM_PNR_SCHEDULE",
  "CONNECTION_DISRUPTION",
];

/** Mirrors is_whole_flight_eligible from the claims_types seed (Vue SelectClaimType.vue). */
const WHOLE_FLIGHT_ELIGIBLE_CLAIM_TYPES = new Set<ClaimTypeName>(["FLIGHT_DELAY", "FLIGHT_CANCELLATION"]);

interface SelectClaimTypeProps {
  usersCount: number;
  value: ClaimTypeName;
  onSelectionUpdate: (claimTypeName: ClaimTypeName) => void;
  className?: string;
}

/** Port of SelectClaimType.vue — claim type picker for the extraction flow. */
export function SelectClaimType({ usersCount, value, onSelectionUpdate, className }: SelectClaimTypeProps) {
  function isDisabled(claimTypeName: ClaimTypeName): boolean {
    return !WHOLE_FLIGHT_ELIGIBLE_CLAIM_TYPES.has(claimTypeName) && usersCount > 1;
  }

  return (
    <div className={className}>
      <Label className="block text-left text-sm font-medium text-gray-700">Nouvelle claim</Label>
      <Select
        value={value}
        onValueChange={(next) => {
          if (next) {
            onSelectionUpdate(next as ClaimTypeName);
          }
        }}
      >
        <SelectTrigger className="mt-1 w-full">
          <SelectValue>{getClaimTypeDisplayName(value, { emoji: true })}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {CLAIM_TYPE_NAMES.map((claimTypeName) => (
            <SelectItem key={claimTypeName} value={claimTypeName} disabled={isDisabled(claimTypeName)}>
              {getClaimTypeDisplayName(claimTypeName, { emoji: true })}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
